<nav
  class="navbar navbar-inverse navbar-fixed-top"
  role="navigation"
  id="mainNav"
>
  <div class="navbar-header">
    <button
      type="button"
      class="navbar-toggle"
      data-toggle="collapse"
      data-target="#jg-navbar-collapse"
    >
      <span class="sr-only">Toggle navigation</span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </button>
    <a class="navbar-brand" [routerLink]="['/home']"> ProManual </a>
  </div>
  <div class="collapse navbar-collapse" id="jg-navbar-collapse">
    <ul class="nav navbar-nav" *ngIf="isLoggedIn">
      <li *ngIf="hasPermission('Users')">
        <a [routerLink]="['/user']">
          <i class="fa fa-fw fa-user"></i>
          <span>Users </span>
        </a>
      </li>
      <li *ngIf="hasPermission('Device')">
        <a [routerLink]="['/devices']">
          <i class="fa fa-fw fa-tablet"></i>
          <span>Devices </span>
        </a>
      </li>
      <li
        class="dropdown"
        *ngIf="hasPermission('Associations') || hasPermission('Assets') || hasPermission('AssetDetails')"
      >
        <a href="" class="dropdown-toggle" data-toggle="dropdown">
          <i class="fa fa-fw fa-lock"></i>
          <span>Associations </span>
          <b class="caret"></b>
        </a>
        <ul class="dropdown-menu">
          <li *ngIf="hasPermission('Associations')">
            <a [routerLink]="['/association/equipment']">
              <i class="fa fa-fw fa-columns"></i>
              <span>Equipment Associations</span>
            </a>
          </li>
          <li *ngIf="hasPermission('Assets')">
            <a [routerLink]="['/association/document']">
              <i class="fa fa-fw fa-list-alt"></i>
              <span>Document Associations</span>
            </a>
          </li>
          <li *ngIf="hasPermission('AssetDetails')">
            <a [routerLink]="['/association/documentdetails']">
              <i class="fa fa-fw fa-list"></i>
              <span>Document Details</span>
            </a>
          </li>
          <li *ngIf="hasPermission('AssetDetails')">
            <a
              role="button"
              tabindex="0"
              style="cursor: pointer"
              [attr.aria-busy]="isDownloadingDocumentDetailReport"
              (click)="downloadDocumentDetailReport()"
              (keydown.enter)="downloadDocumentDetailReport()"
              (keydown.space)="downloadDocumentDetailReport()"
            >
              <i
                *ngIf="!isDownloadingDocumentDetailReport"
                class="fa fa-fw fa-list"
              ></i>
              <i
                *ngIf="isDownloadingDocumentDetailReport"
                class="fa fa-fw fa-spinner fa-spin"
              ></i>
              <span>Document Details Excel Download</span>
            </a>
          </li>
        </ul>
      </li>
      <li
        class="dropdow"
        *ngIf="hasPermission('CodeManagement') || hasPermission('Language') || hasPermission('DocumentManagement') || hasPermission('PrintManagement')"
      >
        <a href="" class="dropdown-toggle" data-toggle="dropdown">
          <i class="fa fa-fw fa-cog"></i>
          <span>Administration </span>
          <b class="caret"></b>
        </a>
        <ul class="dropdown-menu">
          <li *ngIf="hasPermission('CodeManagement')">
            <a [routerLink]="['/administration/codemanagement']">
              <i class="fa fa-fw fa-map-marker"></i>
              <span>Code Management </span>
            </a>
          </li>
          <li *ngIf="hasPermission('DocumentManagement')">
            <a [routerLink]="['/administration/fmiproduct']">
              <i class="fa fa-fw fa-list-alt"></i>
              <span>Document Management</span>
            </a>
          </li>
          <li *ngIf="hasPermission('DocumentManagement')">
            <a [routerLink]="['/administration/survey']">
              <i class="fa fa-fw fa-list-alt"></i>
              <span>Survey Management</span>
            </a>
          </li>
          <li *ngIf="hasPermission('DocumentPresets')">
            <a [routerLink]="['/association/preset']">
              <i class="fa fa-fw fa-list-alt"></i>
              <span>Document Presets</span>
            </a>
          </li>
          <li *ngIf="hasPermission('PartsManualManagement')">
            <a [routerLink]="['/administration/partsmanual']">
              <i class="fa fa-fw fa-list-alt"></i>
              <span>Parts Manual URL Management</span>
            </a>
          </li>
          <li *ngIf="hasPermission('PrintManagement')">
            <a [routerLink]="['/administration/pmdocuments']">
              <i class="fa fa-fw fa-print"></i>
              <span>Print Management - Documents</span>
            </a>
          </li>
          <li *ngIf="hasPermission('PrintManagement')">
            <a [routerLink]="['/administration/pmusers']">
              <i class="fa fa-fw fa-print"></i>
              <span>Print Management - Users</span>
            </a>
          </li>
          <li *ngIf="hasPermission('Language')">
            <a [routerLink]="['/administration/languagepack']">
              <i class="fa fa-fw fa-pencil"></i>
              <span>Language Packs</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/administration/reports']">
              <i class="fa fa-fw fa-columns"></i>
              <span>Reports</span>
            </a>
          </li>
          <li *ngIf="hasPermission('DocumentManagement')">
            <a
              role="button"
              tabindex="0"
              style="cursor: pointer"
              [attr.aria-busy]="isDownloadingFMIVerificationReport"
              (click)="downloadFMIVerificationReport()"
              (keydown.enter)="downloadFMIVerificationReport()"
              (keydown.space)="downloadFMIVerificationReport()"
            >
              <i
                *ngIf="!isDownloadingFMIVerificationReport"
                class="fa fa-fw fa-refresh"
              ></i>
              <i
                *ngIf="isDownloadingFMIVerificationReport"
                class="fa fa-fw fa-spinner fa-spin"
              ></i>
              <span>FMI Verification</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="dropdow" *ngIf="hasPermission('Assets')">
                <a href="" class="dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-fw fa-columns"></i>
                    <span>Analytics</span>
                    <b class="caret"></b>
                </a>
                <ul class="dropdown-menu">
                    <li *ngIf="hasPermission('Assets')">
                        <a [routerLink]="['/analytics/customdashboard']">
                            <i class="fa fa-fw fa-list-alt"></i>
                            <span>Dashboard</span>
                        </a>
                    </li>
                    <li *ngIf="hasPermission('Assets')">
                        <a [routerLink]="['/analytics/chartdetails']">
                            <i class="fa fa-fw fa-list-alt"></i>
                            <span>Chart Details</span>
                        </a>
                    </li>
                </ul>
            </li>
    </ul>
    <ul
      class="nav navbar-nav navbar-right navbar-user"
      style="margin-right: 0px"
      *ngIf="isLoggedIn"
    >
      <li>
        <a [routerLink]="['/annotations']">
          <i class="fa fa-fw fa-envelope"></i>
          <span>Annotations </span>
          <span>{{ newAnnotations }} new ({{ totalAnnotations }} total)</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['/account']">
          <i class="fa fa-fw fa-user"></i>
          <span>Account</span>
        </a>
      </li>
    </ul>
  </div>
</nav>
<router-outlet></router-outlet>

<footer>
  <nav
    class="navbar navbar-inverse navbar-fixed-bottom"
    style="height: 40px !important"
  >
    <div style="display: flex; flex-wrap: nowrap; align-items: center; justify-content: space-between;">
      <div>
        <div class="navbar-header">
          <a class="navbar-brand" style="font-size: 14px"
            >&copy; {{ copyRightYear }} Xorbix Technologies, Inc.</a
          >
        </div>
      </div>
      <div>
        <div class="navbar-header">
          <span
            class="navbar-brand"
            style="font-size: 12px"
            *ngIf="bUpdateFMIFTP == 'false'"
            >*** FMI/FTP Simulation Mode ***</span
          >
          <span
            class="navbar-brand"
            style="font-size: 12px"
            *ngIf="bUpdateFMIFTP == 'true'"
            >*** FMI/FTP Updates Turned On ***</span
          >
        </div>
      </div>
      <div style="padding-right: 1em; flex-grow: 1;">
        <ul class="nav navbar-nav navbar-right">
          <li class="navbar-brand" style="padding-right: 4px; font-size: 12px">
            Android Version: {{ andVersion }}
          </li>
          <li class="navbar-brand" style="padding-right: 4px; font-size: 12px">
            iOS Version: {{ iosVersion }}
          </li>
          <li class="navbar-brand" style="padding-right: 4px; font-size: 12px">
            UWP Store Version: {{ uwpVersion }}
          </li>
          <li class="navbar-brand" style="padding-right: 4px; font-size: 12px">
            UWP Side Load Version: {{ uwpslVersion }}
          </li>
          <li class="navbar-brand" style="padding-right: 15px; font-size: 12px">
            Admin Version: {{ version }}
          </li>
          <li class="navbar-brand" style="padding-right: 15px; font-size: 12px">
            Db: {{ datasetSource }}
          </li>
        </ul>
      </div>
    </div>
  </nav>
</footer>
<delete-confirmation></delete-confirmation>
